/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CancelOrderRequest,
  CreateOrderDtoV3,
  CreateOrderV3Response,
  GetIcsResponse,
  GetOrderDigitalProductResponse,
  GetPurchasedAvatarMeMediaResponse,
  GetPurchasedDigitalAssetResponse,
  OrdersDetailWithRefundResponse,
  PreviewOrderDto,
  PreviewOrderResponse,
  RefundOrderRequest,
  RescheduleMeetingOrderRequest,
  RetryPaymentRequest,
  RetryPaymentResponse,
} from '../models/index';

export interface OrderApiControllerCancelOrderRequest {
    orderId: string;
    CancelOrderRequest: CancelOrderRequest;
}

export interface OrderApiControllerCreateOrderInMultiCurrencyRequest {
    CreateOrderDtoV3: CreateOrderDtoV3;
}

export interface OrderApiControllerDownloadIcsRequest {
    orderId: string;
}

export interface OrderApiControllerGetOrderDigitalAssetRequest {
    orderId: string;
}

export interface OrderApiControllerGetPurchasedAvatarMeMediaRequest {
    orderId: string;
}

export interface OrderApiControllerGetPurchasedDigitalAssetRequest {
    listingId: string;
}

export interface OrderApiControllerOrdersDetailWithRefundRequest {
    orderId: string;
    includeOrdersInSameOrderGroup?: boolean;
}

export interface OrderApiControllerPreviewOrderRequest {
    PreviewOrderDto: PreviewOrderDto;
    user_agent?: string;
    x_pop_platform?: OrderApiControllerPreviewOrderXPopPlatformEnum;
}

export interface OrderApiControllerRefundRequest {
    orderId: string;
    RefundOrderRequest: RefundOrderRequest;
}

export interface OrderApiControllerRescheduleMeetingOrderRequest {
    orderId: string;
    RescheduleMeetingOrderRequest: RescheduleMeetingOrderRequest;
}

export interface OrderApiControllerRetryOrderPaymentRequest {
    orderId: string;
    RetryPaymentRequest: RetryPaymentRequest;
}

/**
 * 
 */
export class OrderApi extends runtime.BaseAPI {

    /**
     */
    async orderApiControllerCancelOrderRaw(requestParameters: OrderApiControllerCancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderApiControllerCancelOrder().'
            );
        }

        if (requestParameters['CancelOrderRequest'] == null) {
            throw new runtime.RequiredError(
                'CancelOrderRequest',
                'Required parameter "CancelOrderRequest" was null or undefined when calling orderApiControllerCancelOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/orders/{orderId}:cancel`;
        urlPath = urlPath.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CancelOrderRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerCancelOrder(requestParameters: OrderApiControllerCancelOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.orderApiControllerCancelOrderRaw(requestParameters, initOverrides);
    }

    /**
     */
    async orderApiControllerCreateOrderInMultiCurrencyRaw(requestParameters: OrderApiControllerCreateOrderInMultiCurrencyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrderV3Response>> {
        if (requestParameters['CreateOrderDtoV3'] == null) {
            throw new runtime.RequiredError(
                'CreateOrderDtoV3',
                'Required parameter "CreateOrderDtoV3" was null or undefined when calling orderApiControllerCreateOrderInMultiCurrency().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v3/orders`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateOrderDtoV3'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerCreateOrderInMultiCurrency(requestParameters: OrderApiControllerCreateOrderInMultiCurrencyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrderV3Response> {
        const response = await this.orderApiControllerCreateOrderInMultiCurrencyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async orderApiControllerDownloadIcsRaw(requestParameters: OrderApiControllerDownloadIcsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetIcsResponse>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderApiControllerDownloadIcs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/orders/{orderId}:getIcs`;
        urlPath = urlPath.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerDownloadIcs(requestParameters: OrderApiControllerDownloadIcsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetIcsResponse> {
        const response = await this.orderApiControllerDownloadIcsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async orderApiControllerGetOrderDigitalAssetRaw(requestParameters: OrderApiControllerGetOrderDigitalAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrderDigitalProductResponse>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderApiControllerGetOrderDigitalAsset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/orders/{orderId}:getDigitalAsset`;
        urlPath = urlPath.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerGetOrderDigitalAsset(requestParameters: OrderApiControllerGetOrderDigitalAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrderDigitalProductResponse> {
        const response = await this.orderApiControllerGetOrderDigitalAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async orderApiControllerGetPurchasedAvatarMeMediaRaw(requestParameters: OrderApiControllerGetPurchasedAvatarMeMediaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPurchasedAvatarMeMediaResponse>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderApiControllerGetPurchasedAvatarMeMedia().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/orders/{orderId}:getPurchasedAvatarMeMedia`;
        urlPath = urlPath.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerGetPurchasedAvatarMeMedia(requestParameters: OrderApiControllerGetPurchasedAvatarMeMediaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPurchasedAvatarMeMediaResponse> {
        const response = await this.orderApiControllerGetPurchasedAvatarMeMediaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async orderApiControllerGetPurchasedDigitalAssetRaw(requestParameters: OrderApiControllerGetPurchasedDigitalAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPurchasedDigitalAssetResponse>> {
        if (requestParameters['listingId'] == null) {
            throw new runtime.RequiredError(
                'listingId',
                'Required parameter "listingId" was null or undefined when calling orderApiControllerGetPurchasedDigitalAsset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/listings/{listingId}:getPurchasedDigitalAsset`;
        urlPath = urlPath.replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters['listingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerGetPurchasedDigitalAsset(requestParameters: OrderApiControllerGetPurchasedDigitalAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPurchasedDigitalAssetResponse> {
        const response = await this.orderApiControllerGetPurchasedDigitalAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async orderApiControllerOrdersDetailWithRefundRaw(requestParameters: OrderApiControllerOrdersDetailWithRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersDetailWithRefundResponse>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderApiControllerOrdersDetailWithRefund().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeOrdersInSameOrderGroup'] != null) {
            queryParameters['includeOrdersInSameOrderGroup'] = requestParameters['includeOrdersInSameOrderGroup'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/orders/{orderId}:detail`;
        urlPath = urlPath.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerOrdersDetailWithRefund(requestParameters: OrderApiControllerOrdersDetailWithRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersDetailWithRefundResponse> {
        const response = await this.orderApiControllerOrdersDetailWithRefundRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async orderApiControllerPreviewOrderRaw(requestParameters: OrderApiControllerPreviewOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreviewOrderResponse>> {
        if (requestParameters['PreviewOrderDto'] == null) {
            throw new runtime.RequiredError(
                'PreviewOrderDto',
                'Required parameter "PreviewOrderDto" was null or undefined when calling orderApiControllerPreviewOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['user_agent'] != null) {
            headerParameters['user-agent'] = String(requestParameters['user_agent']);
        }

        if (requestParameters['x_pop_platform'] != null) {
            headerParameters['x-pop-platform'] = String(requestParameters['x_pop_platform']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/orders:preview`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['PreviewOrderDto'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerPreviewOrder(requestParameters: OrderApiControllerPreviewOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreviewOrderResponse> {
        const response = await this.orderApiControllerPreviewOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async orderApiControllerRefundRaw(requestParameters: OrderApiControllerRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderApiControllerRefund().'
            );
        }

        if (requestParameters['RefundOrderRequest'] == null) {
            throw new runtime.RequiredError(
                'RefundOrderRequest',
                'Required parameter "RefundOrderRequest" was null or undefined when calling orderApiControllerRefund().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/orders/{orderId}:refund`;
        urlPath = urlPath.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['RefundOrderRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerRefund(requestParameters: OrderApiControllerRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.orderApiControllerRefundRaw(requestParameters, initOverrides);
    }

    /**
     */
    async orderApiControllerRescheduleMeetingOrderRaw(requestParameters: OrderApiControllerRescheduleMeetingOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderApiControllerRescheduleMeetingOrder().'
            );
        }

        if (requestParameters['RescheduleMeetingOrderRequest'] == null) {
            throw new runtime.RequiredError(
                'RescheduleMeetingOrderRequest',
                'Required parameter "RescheduleMeetingOrderRequest" was null or undefined when calling orderApiControllerRescheduleMeetingOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/meeting-orders/{orderId}:reschedule`;
        urlPath = urlPath.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['RescheduleMeetingOrderRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderApiControllerRescheduleMeetingOrder(requestParameters: OrderApiControllerRescheduleMeetingOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.orderApiControllerRescheduleMeetingOrderRaw(requestParameters, initOverrides);
    }

    /**
     */
    async orderApiControllerRetryOrderPaymentRaw(requestParameters: OrderApiControllerRetryOrderPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RetryPaymentResponse>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderApiControllerRetryOrderPayment().'
            );
        }

        if (requestParameters['RetryPaymentRequest'] == null) {
            throw new runtime.RequiredError(
                'RetryPaymentRequest',
                'Required parameter "RetryPaymentRequest" was null or undefined when calling orderApiControllerRetryOrderPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/orders/{orderId}:retry-payment`;
        urlPath = urlPath.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['RetryPaymentRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async orderApiControllerRetryOrderPayment(requestParameters: OrderApiControllerRetryOrderPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RetryPaymentResponse> {
        const response = await this.orderApiControllerRetryOrderPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const OrderApiControllerPreviewOrderXPopPlatformEnum = {
    Psl: 'psl',
    Popstore: 'popstore'
} as const;
export type OrderApiControllerPreviewOrderXPopPlatformEnum = typeof OrderApiControllerPreviewOrderXPopPlatformEnum[keyof typeof OrderApiControllerPreviewOrderXPopPlatformEnum];
